import Vue from "vue";
import Vuex from "vuex";
import * as auth from "./auth.module";
import * as storage from "./storage.module";
import Constant from "./constant";
import FacilityService from "@/services/facility/facility.service";
import core from "@/core";
import { RouterBeforeTask } from "@/router/router-before-task";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  app: {
    publicPath: process.env.BASE_URL,
    constant: Constant,
    facilityId: null,
    facilityList: null,
    headerFacilityList: null,
    modal: {
      profile: {
        visible: false,
      },
      changePassword: {
        visible: false,
      },
    },
    getUrl(path) {
      if (path == null) path = "";
      else if (path.startsWith("data:")) return path;

      if (this.publicPath.length > 0) {
        const cc = this.publicPath.substr(
          this.publicPath.length - 1,
          this.publicPath.length,
        );
        if (cc === "/") {
          if (path.startsWith("/")) {
            return this.publicPath.substr(0, this.publicPath.length - 1) + path;
          }
          return this.publicPath + path;
        }
        return this.publicPath + path;
      }
      return path;
    },
  },
  routerBeforeTask: new RouterBeforeTask(),
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  updateFacilityList(state, facilityList) {
    //console.log('mutations[login]: ', user);
    console.log("update facilityList", facilityList);
    state.app.facilityList = facilityList;
    state.app.headerFacilityList = core.utils.deepCopy(state.app.facilityList);

    let existsFacilityId = false;
    state.app.headerFacilityList.forEach((facility) => {
      facility.label = `${facility.name}(${facility.cropName})`;
      if (
        state.app.facilityId != null &&
        state.app.facilityId === facility.id
      ) {
        existsFacilityId = true;
      }
    });

    if (!existsFacilityId) {
      state.app.facilityId = null;
    }
  },
};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    auth,
    storage,
  },
  actions: {
    async getFacilityList({ commit }, reloadFlag) {
      if (reloadFlag == null) reloadFlag = false;
      if (state.app.facilityList == null || reloadFlag) {
        try {
          await FacilityService.getList();
          if (state.app.facilityId == null) {
            const item = localStorage.getItem(
              state.auth.user.id + "_facilityId",
            );
            if (item != null) {
              const facilityId = Number(item);
              if (!isNaN(facilityId)) {
                state.app.facilityId = facilityId;
                console.log("state.app.facilityId : ", state.app.facilityId);
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
      return state.app.facilityList;
    },
  },
});
